var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{ref:"qrRef"})])
}
var staticRenderFns = []

export { render, staticRenderFns }